<template>
  <!-- 文创 -->
  <div class="page-creative">
    <div class="g-banner">
      <cmpBanner bannerType="6"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal"></cmpTab>
      </div>
    </div>

    <div class="g-content-wrap g-pad-top">
      <!-- 搜索条件 -->
      <!-- <div class="com-list-header mb-20">
        <el-form class="com-search-box" ref="form" :model="form" label-width="0">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="" prop="type">
                <el-select v-model="form.type" clearable placeholder="文创类别" style="width:100%;" @change="handleSearch">
                  <el-option
                    v-for="item in typeList"
                    :key="item.dictCode"
                    :label="item.dictName"
                    :value="item.dictCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div> -->

      <div class="list g-card-list g-pad-bottom-2">
        <div class="item g-card-1" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)" style="margin-bottom:40px;">
          <div class="pic-box">
            <img v-lazy="item.attId" alt="">
          </div>
          <div class="info">
            <div>
              <h2>{{item.title}}</h2>
              <p class="m-font-4">｜{{item.ext3}}</p>
            </div>
            <div class="desc">
              <p class="price"><i class="mr-5">¥</i>{{item.price}}</p>
            </div>
          </div>
        </div>

        <!-- 无数据 -->
        <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
          <div class="no-data-bg"></div>
          <p class="txt text-center">暂无数据</p>
        </div>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
export default {
  components: { cmpTab },
  data() {
    return {
      activeVal: '1',
      tabList: [
        {
          name: '文创产品',
          val: '1'
        }
      ],
      form: {
        type: '',
      },
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 9,
      },
      total: 0,
      listLoading: false,
      typeList: [],
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/culturalCreativity/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    getDictData() {
      this.$http
        .get('../singleMuseum/collectDict/getSelectDataByKey?key=cc_type', {
        }).then(res => {
          if (res.success) {
            this.typeList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
    goDetail(item) {
      this.$router.push({
        path: '/creative/detail',
        query: {id: item.id}
      })
    },
  },
  created() {
    this.getDictData()
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-creative {
  .pic-box {
    // height: 288px;
    img {
      object-fit: contain;
    }
  }
}
</style>

